import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getFeaturedProducts, getPortada } from '../services/api';
import ProductCard from '../components/product/ProductCard';
import { Loader2 } from 'lucide-react';

// Featured Hero Component with Portada
const FeaturedHero = ({ portada }) => {
  if (!portada) return null;

  return (
    <div 
      className="relative min-h-[70vh] flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url(${portada.imageUrl})`,
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          {portada.title}
        </h1>
        <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
          {portada.subtitle}
        </p>
      </div>
    </div>
  );
};

const Featured = () => {
  const { t } = useLanguage();
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [portada, setPortada] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsData, portadaData] = await Promise.all([
          getFeaturedProducts(),
          getPortada('featured')
        ]);
        setFeaturedProducts(productsData);
        setPortada(portadaData);
      } catch (error) {
        console.error('Error loading featured data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      {/* Portada grande premium */}
      <FeaturedHero portada={portada} />

      {/* Productos destacados debajo */}
      <section className="py-20 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {featuredProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>

          {featuredProducts.length === 0 && (
            <div className="text-center py-20">
              <p className="text-muted-foreground">
                No hay productos destacados disponibles
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Featured;
